import { c as _c } from "react/compiler-runtime";
import { ANALYTICS_CHART_MARGIN } from "@components/analytics/analytics-charts";
import { SphereBarChart } from "@components/common/sphere-bar-chart/sphere-bar-chart";
import { useMediaQueryList } from "@hooks/use-media-query";
import { CommonStyles } from "@styles/common-styles";
import { useMemo } from "react";

/* eslint-disable @typescript-eslint/no-magic-numbers -- aspect ratio value */
/**
 * Aspect ratio of a full-width chart: twice as wide as the half-width charts at the same height,
 * so a lone chart spans the row without growing taller.
 */
const FULL_WIDTH_CHART_ASPECT_RATIO = 8 / 3;
/* eslint-enable @typescript-eslint/no-magic-numbers */

/** Renders a single analytics bar chart */
export function AnalyticsBarChart(t0) {
  const $ = _c(9);
  const {
    data,
    shouldShowSkeleton,
    isFullWidth: t1
  } = t0;
  const isFullWidth = t1 === undefined ? false : t1;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const shouldSpanFullWidth = isFullWidth && !isScreenSmOrSmaller;
  let t2;
  bb0: {
    if (shouldShowSkeleton) {
      t2 = "0px";
      break bb0;
    }
    t2 = isScreenSmOrSmaller ? "10px" : "20px";
  }
  const padding = t2;
  const t3 = shouldSpanFullWidth ? FULL_WIDTH_CHART_ASPECT_RATIO : undefined;
  const t4 = isScreenSmOrSmaller || isFullWidth ? "100%" : `calc(50% - ${ANALYTICS_CHART_MARGIN}/2)`;
  const t5 = shouldShowSkeleton ? "none" : CommonStyles.Borders.divider;
  let t6;
  if ($[0] !== padding || $[1] !== t4 || $[2] !== t5) {
    t6 = {
      width: t4,
      border: t5,
      padding,
      marginBottom: ANALYTICS_CHART_MARGIN
    };
    $[0] = padding;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== data || $[5] !== shouldShowSkeleton || $[6] !== t3 || $[7] !== t6) {
    t7 = <SphereBarChart data={data} shouldShowSkeleton={shouldShowSkeleton} aspectRatio={t3} sx={t6} />;
    $[4] = data;
    $[5] = shouldShowSkeleton;
    $[6] = t3;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}